var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79584 0.837605C5.7571 0.798551 5.71102 0.767553 5.66025 0.7464C5.60947 0.725246 5.55501 0.714355 5.50001 0.714355C5.445 0.714355 5.39054 0.725246 5.33976 0.7464C5.28899 0.767553 5.24291 0.798551 5.20417 0.837605L3.29584 2.74593C3.2571 2.78499 3.21102 2.81598 3.16025 2.83714C3.10947 2.85829 3.05501 2.86918 3.00001 2.86918C2.945 2.86918 2.89054 2.85829 2.83976 2.83714C2.78899 2.81598 2.74291 2.78499 2.70417 2.74593L0.795838 0.837605C0.757104 0.798551 0.71102 0.767553 0.660245 0.7464C0.60947 0.725246 0.55501 0.714355 0.500005 0.714355C0.445 0.714355 0.390539 0.725246 0.339764 0.7464C0.28899 0.767553 0.242906 0.798551 0.204171 0.837605C0.126567 0.915672 0.0830078 1.02128 0.0830078 1.13135C0.0830078 1.24143 0.126567 1.34704 0.204171 1.4251L2.11667 3.3376C2.35105 3.57168 2.66875 3.70317 3.00001 3.70317C3.33126 3.70317 3.64896 3.57168 3.88334 3.3376L5.79584 1.4251C5.87344 1.34704 5.917 1.24143 5.917 1.13135C5.917 1.02128 5.87344 0.915672 5.79584 0.837605V0.837605Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDown);
export default __webpack_public_path__ + "static/media/vector_down.cc9c89d071f04864dc6b41045e0dcb7e.svg";
export { ForwardRef as ReactComponent };